<template>
    <div>
      <common-dialog
        ref="dialog"
        width="700px"
        :show-save-button="$permission.canEdit()"
        unit="商品标签"
        edit-title
        id-key="RecordId"
        :data="data"
        form-label-width="125px"
        :form-rules="rules"
        :save-func="api.save"
        @create-opened="onCreateOpened"
        @edit-opened="onEditOpened"
        close-on-saved
        :before-save="onBeforeSave"
        @closed="onClosed"
        @close-saved="$emit('close-saved')"
      >
        <template slot="form">
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="标签名称" prop="LabelName">
                <el-input v-model="data.LabelName" placeholder="请填写标签名称" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="状态" prop="State">
                <el-radio-group v-model="data.State">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="序号" prop="OrderId">
                <el-input-number v-model="data.OrderId" :min="0" />
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template #footer v-if="!$permission.canEdit()">
           <el-button @click="close">关 闭</el-button>
      </template>
      </common-dialog>
    </div>
  </template>
  <script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
   
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,     
    },
    data() {
      return {
        data: {
          RecordId: 0,
          LabelName: "",
          OrderId: 0,
          State: 1,
        },
        api: require("@/api/goods/label").default,
        isMB: this.$store.state.isMB,
        rules: {
          LabelName: [{ required: true, message: "标签名称不能为空" }],
          OrderId: [{ required: true, message: "序号不能为空" }],
        },
      };
    },
    methods: {
      onCreateOpened(row) {
        this.api.getMaxOrderId().then(res => {
          if(res.Code==0) this.data.OrderId = res.Data;
        })
      },
      onEditOpened(row) {
        
      },
      onBeforeSave() {
        
      },
      onClosed() {
  
      },
    },
  };
  </script>